import { useContext, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { CloudUpload, Delete, ZoomIn } from '@mui/icons-material';
import { GarantiasContext } from 'contexts/GarantiasContext';
import { AuthContext } from 'contexts/AuthContext';
import { decryptURL } from 'utils/functions';
import Container from 'components/Container';
import Header from 'components/Header';
import Button from 'components/Button';
import Card from 'components/Card';
import styles from './styles';

const Concluir = () => {
  const navigate = useNavigate();
  const inputRef = useRef();
  const { hash } = useParams();
  const { user } = useContext(AuthContext);
  const { postLoading, postConclusao } = useContext(GarantiasContext);
  const [imagem, setImagem] = useState(null);
  const decrypt = decryptURL(hash);

  const handleSelectImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setImagem({ file, preview });
    }
  };

  const handleRemove = () => {
    setImagem(null);
    inputRef.current.value = '';
  };

  const handleClickUpload = () => {
    inputRef.current.click();
  };

  const handleSubmit = () => {
    const documento = {
      Itens: [
        {
          id: decrypt?.id,
          documento_id: decrypt?.documento_id,
          Aprovacoes: [
            {
              documento_item_id: decrypt?.id,
              aprova_id: 11,
              motivo: 'Pagamento do serviço',
            },
          ],
        },
      ],
    };

    const data = new FormData();
    data.append('documento', JSON.stringify(documento));
    data.append('midia', imagem?.file);

    postConclusao({ data, cb: () => navigate(-1) });
  };

  return (
    <Container>
      <Header titulo="Concluir Garantia" />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} display={Boolean(imagem) ? 'none' : 'block'}>
            <Box sx={styles?.imgArea} onClick={handleClickUpload}>
              <CloudUpload fontSize="large" />
              <Typography mt={1}>Clique para adicionar uma imagem</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} display={Boolean(imagem) ? 'block' : 'none'}>
            <Box position="relative" display="inline-block">
              <Box
                alt="preview"
                loading="lazy"
                component="img"
                sx={styles?.img}
                src={imagem?.preview}
              />
              <Box position="absolute" display="flex" right={8} top={8} gap={1}>
                <IconButton
                  size="small"
                  color="primary"
                  sx={styles?.icon}
                  onClick={() => window.open(imagem?.preview, '_blank')}
                >
                  <ZoomIn fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  color="primary"
                  sx={styles?.icon}
                  onClick={handleRemove}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="body2" color="warning.main">
              Ao concluir esta garantia, será gerada uma despesa no valor de R$
              70,00.
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              disabled={!imagem}
              variant="contained"
              loading={postLoading}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
        <input
          type="file"
          hidden
          ref={inputRef}
          accept="image/*"
          onChange={handleSelectImage}
        />
      </Card>
    </Container>
  );
};

export default Concluir;
